// Common styles for the application

export const cardStyles = {
  container: "w-16 h-16 rounded flex items-center justify-center relative",
  cardBase:
    "w-14 h-14 rounded bg-white shadow-md flex items-center justify-center",
  cardCompact:
    "w-14 h-7 rounded bg-white shadow-md flex items-center justify-center mb-1",
  emptySlot: "w-14 h-14 rounded border border-dashed border-white/30",
  tableauContainer:
    "w-16 min-h-16 rounded-lg flex flex-col items-start p-1 bg-slate-700/50",
};

export const ringStyles = {
  selected: "ring-4 ring-pink-500",
  validDestination: "ring-4 ring-amber-500 hover:bg-slate-700 cursor-pointer",
  default: "ring-2 ring-gray-500",
};

export const buttonStyles = {
  primary:
    "bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-3 rounded text-sm flex items-center justify-center transition-colors duration-200",
  icon: "text-white p-2 rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-all duration-200 hover:shadow-lg transform hover:scale-105",
};

export const getRingStyle = (
  isSelected: boolean,
  isValidDestination: boolean,
): string => {
  if (isSelected) return ringStyles.selected;
  if (isValidDestination) return ringStyles.validDestination;
  return ringStyles.default;
};
